import { Controller } from "@hotwired/stimulus"

// Keeps the sticky My Tasks dock on screen. The sidebar is capped at 100vh - 2rem, which assumes it
// starts 1rem from the top; before the page scrolls it starts below the site header, so its bottom
// edge (where the dock sticks) sits below the fold. Fit the sidebar to end at the viewport bottom.
const BOTTOM_GAP_PX = 16;

export default class extends Controller {
  connect() {
    this.sidebar = this.element.closest("#dashboard-sidebar");
    if (!this.sidebar) return;

    this.fit = this.fit.bind(this);
    this.scheduleFit = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.fit(); });
    };

    window.addEventListener("scroll", this.scheduleFit, { passive: true });
    window.addEventListener("resize", this.scheduleFit);
    this.fit();
  }

  disconnect() {
    window.removeEventListener("scroll", this.scheduleFit);
    window.removeEventListener("resize", this.scheduleFit);
    if (this.frame) cancelAnimationFrame(this.frame);
    if (this.sidebar) this.sidebar.style.maxHeight = "";
  }

  fit() {
    // Only on desktop, where the sidebar is sticky and scrolls on its own.
    if (getComputedStyle(this.sidebar).position !== "sticky") {
      this.sidebar.style.maxHeight = "";
      return;
    }

    const top = Math.max(this.sidebar.getBoundingClientRect().top, 0);
    this.sidebar.style.maxHeight = `${window.innerHeight - top - BOTTOM_GAP_PX}px`;
  }
}
